export default Object.freeze({
  // Global messages and UI elements
  common: {
    // User roles
    student: "Estudiante",
    admin: "Administrador",
    teacher: "Maestro",
    staff: "Personal",
    school: "Escuela",
    system: "Sistema",

    // Actions
    log_out: "Cerrar Sesión",
    edit: "Editar",
    submit: "Enviar",
    go_back: "Volver",
    select_one: "Seleccionar uno",
    this_option_is_required: "Esta opción es requerida",
    this_field_is_required: "Este campo es requerido",
    reason_for_pass_is_required: "El motivo del pase es requerido",
    start_point_and_destination_point_should_not_be_the_same:
      "El punto de inicio y el punto de destino no deben ser el mismo",
    the_pin_may_not_be_greater_than_6_characters:
      "El PIN no puede ser mayor a 6 caracteres",
    the_pin_should_be_at_least_4_characters:
      "El PIN debe tener al menos 4 caracteres",
    cancel_request: "Cancelar Solicitud",
    cancel_pass: "Cancelar Pase",
    close: "Cerrar",
    do_you_really_want_to_cancel_the_pass:
      "¿Realmente quieres cancelar el pase?",
    cancel: "Cancelar",
    staff_use_only: "Solo para personal",
    enter_your_pin: "Ingresa tu PIN",
    approve: "Aprobar",
    arrived: "Llegó",
    in_out: "En/Fuera",
    returning: "Regresando",
    end_keep: "Finalizar/Mantener",
    end: "Finalizar",
    enter_room_pin: "Ingresa el PIN del salón",
    the_time_must_be_30_minutes_from_now_and_not_more_than_a_month:
      "El tiempo debe ser de 30 minutos a partir de ahora y no más de un mes!",
    you_must_pick_a_time_between_6am_and_5pm:
      "Debes seleccionar una hora entre las 6AM y las 5PM.",
    select_teacher_or_rooms: "Seleccionar Maestro o Salones",

    // Navigation and UI
    favorites: "Favoritos",
    add_favorite_teacher_room: "Agregar favorito Maestro / Salón",
    add_remove_favorites: "Agregar/Quitar Favoritos",
    manage_order: "Administrar Orden",
    reset_date: "Fecha de reinicio",
    infraction_step: "Infracción",
    action_type: "Tipo de acción",
    combined_lts_ltc: "Combinado (LTS & LTC)",
    no_items_available: "No hay elementos disponibles",
    no_items: "No hay elementos",
    no_filtering_results: "No hay resultados de filtrado",
    // Form labels
    note: "Nota",
    date: "Fecha",
    period: "Período",
    time: "Hora",
    reason: "Motivo",
    from: "De",
    to: "A",
    status: "Estado",
    actions: "Acciones",

    // Status and conditions
    late_to_school: "Tarde a la Escuela",
    late_to_class: "Tarde a la Clase",
    no_passes: "No hay pases",
    todays_history: "Historial de Hoy",
    currently_waiting_in_line: "Actualmente esperando en la línea",
    comments: "Comentarios",
    you_are: "Usted es",
    start: "Iniciar",
    stop: "Detener",
    check_in: "Registrar",
    this_student_is_flagged_for_3_unsuccessful_pin_attempts:
      "Este estudiante está marcado por 3 intentos fallidos de PIN",
    currently_waiting_for_approval: "Esperando aprobación!",
    total_time_today: "Tiempo total de hoy",
    no_passes_for_today: "No hay pases para hoy.",
    number_of_signatures: "Número de firmas",
    time_out: "Tiempo de salida",
    final_time_in: "Tiempo de entrada final",
    total_time: "Tiempo total",

    // Pass status labels
    in_queue: "En Fila",
    waiting_approval: "Esperando Aprobación",
    active: "Activo",
    ended: "Finalizado",
    canceled: "Cancelado",

    // Pass completion types
    auto_pass: "Pase Automático",
    system_ended: "Finalizado por el Sistema",
    unknown: "Desconocido",
    successfully_updated: "Actualizado exitosamente.",

    // Form components
    select: "Seleccionar",
    select_location: "Seleccionar ubicación",
    loading_more: "Cargando más..",
    sorry_no_matching_options: "Lo siento, no hay opciones disponibles.",
    more: "más",

    // Comments component
    no_comments: "No hay comentarios",
    type_your_comment_here: "Escribe tu comentario aquí ...",
    characters_max: "{count} caracteres máximo",
    comment: "Comentario",
    the_comment_is_required: "¡El comentario es requerido!",
    successfully_created: "¡Creado exitosamente!",
    the_comments_field_is_required: "¡El campo de comentarios es requerido!",
    something_went_wrong: "¡Algo salió mal!",
    my_profile: "Mi perfil",
    my_locations: "Mis ubicaciones",
    premium_feature: "(Función Premium)",
    first_name: "Nombre",
    last_name: "Apellido",
    email: "Email",
    appointment_requests_to_you: "Solicitudes de cita con usted",
    when_the_toggle_is_blue_students_will_be_able_to_create_appointment_requests_to_you:
      "Cuando el interruptor está en azul, los estudiantes podrán crear solicitudes de cita con usted.",
    email_notification: "Notificación por correo electrónico",
    bell_notification: "Notificación por campana",
    notifications_for_appointment_requests:
      "Notificaciones para solicitudes de cita",
    passes_to_from_you: "Pases a/de usted",
    when_the_toggle_is_blue_adults_and_students_will_be_able_to_create_passes_to_from_you:
      "Cuando el interruptor está en azul, los adultos y estudiantes podrán crear pases con/para usted.",
    appointment_pass_email_reminders:
      "Recordatorios de correo electrónico de pases de cita",
    select_which_appointment_pass_reminder_emails_to_be_sent_to_you:
      "Seleccione qué recordatorios de correo electrónico de pases de cita se enviarán a usted.",
    your_pin_needs_to_be_between_4_and_6_letters_numbers_or_characters_long_any_combination_of_these_but_no_spaces:
      "Su PIN debe tener entre 4 y 6 letras, números o caracteres (cualquier combinación de estos, pero sin espacios).",
    kiosk_passcode: "Código de acceso del kiosco",
    save_changes: "Guardar cambios",
    pin: "PIN",
    "20_minute": "20 - minutos",
    "5_minute": "5 - minutos",
    max_35_characters: "máx 35 caracteres",
    clear_all_notifications: "Limpiar todas las notificaciones",
    no_new_notifications: "No hay nuevas notificaciones",
    delete_image: "Eliminar imagen",
    this_image_is_too_large_allowed_maximum_size_is_2mb:
      "Esta imagen es demasiado grande. El tamaño máximo permitido es de 2MB",
    unsupported_image_type: "Tipo de imagen no soportado",
    favorites_limit_reached:
      'Has alcanzado el límite de "Favoritos". Para agregar una nueva ubicación debes eliminar una selección anterior.',

    // DataTable and Pagination
    search: "Buscar",
    sort: "Ordenar",
    export: "Exportar",
    showing: "Mostrando",
    entries: "entradas",
    all_entries: "Todas las entradas",
    per_page: "por página",
    showing_to: "a",
    showing_of: "de",

    // Favorites
    edit_sort_favorites: "Editar / Ordenar Favoritos",
    favorites_note: "Nota",
    can_see_and_sort_favorites:
      "puede ver y ordenar / eliminar solo sus favorito(s).",
    icon: "Icono",
    name: "Nombre",
    action: "Acción",
    delete: "Eliminar"
  },

  // Language selection
  language: {
    select_language: "Seleccionar idioma"
  },

  // Sidebar navigation items (also used for route names)
  sidebar_items: {
    home: "Inicio",
    dashboard: "Panel de Control",
    history: "Historial",
    create_pass: "Crear Pase",
    active_pass: "Pase Activo",
    teacher_pass: "Pase de Maestro",
    appointments: "Citas",
    digital_id: "ID Digital",
    tardy_management: "Gestión de Tardanzas",
    tardy_reports: "Reportes de Tardanzas",
    tardy_detention_appointment_list:
      "Lista de Detenciones y Citas por Tardanzas",
    tardy_appointments: "Citas por Tardanzas",
    detention_attendance: "Asistencia a Detenciones",
    detention_calendar: "Calendario de Detenciones",
    tardy_settings: "Configuración de Tardanzas",
    tardy_adults: "Adultos con Tardanzas",
    tardy_csv_upload: "Carga CSV de Tardanzas",
    tardy_detentions: "Detenciones por Tardanzas",
    consequences_ladder: "Niveles de Sanción",
    visitor_management: "Gestión de Visitantes",
    visitor_settings: "Configuración de Visitantes",
    visitor_adults: "Adultos Visitantes",
    visitor_guardian_student_matrix:
      "Matriz Visitante/Tutor-Estudiante (Matriz Padre/Estudiante)",
    check_ins_and_reports: "Registros y Reportes",
    printer_setup: "Configuración de Impresora",
    queue_settings: "Configuración de Fila",
    retained: "Retenido",
    limits: "Límites",
    limit_student_pass: "Limitar Pase de Estudiante",
    limit_location_max_cap: "Limitar Capacidad Máxima de Ubicación",
    limit_active_pass: "Limitar Pase Activo",
    limit_location_availability: "Limitar Disponibilidad de Ubicación",
    contact_control_ab_polarity: "Control de Contacto (Polaridad A/B)",
    pass_blocking: "Bloqueo de Pases",
    users: "Usuarios",
    main_users: "Usuarios Principales",
    substitute_users: "Usuarios Sustitutos",
    archived_users: "Usuarios Archivados",
    system_settings: "Configuración del Sistema",
    auto_pass: "Pase Automático",
    pass_times: "Horarios de Pases",
    periods: "Períodos",
    locations_rooms: "Ubicaciones (salones)",
    pass_transparency: "Transparencia de Pases",
    modules: "Módulos",
    file_uploads: "Carga de Archivos",
    security_alerts_settings: "Alertas de Seguridad",
    kiosk: "Kiosco",
    kiosk_settings: "Configuración de Kiosco",
    out_of_office: "Fuera de Oficina",
    general_settings: "Configuración General",
    list_settings: "Configuración de Lista",
    help_desk: "Mesa de Ayuda",
    updates: "Actualizaciones",
    training: "Formación",
    documents: "Documentos",
    video_tutorials: "Tutoriales en Video",
    control_panel: "Panel de Control",
    reports: "Reportes",
    summary_reports: "Reportes Resumidos",
    meet_up_report: "Reporte de Encuentros",
    pass_totals: "Totales de Pases",
    profile_settings: "Configuración de Perfil",
    login: "Iniciar Sesión",
    forgotten_password: "Contraseña Olvidada",
    reset_password: "Restablecer Contraseña",
    verify_email: "Verificar Email",
    kiosk_login: "Inicio de Sesión de Kiosco",
    kiosk_system: "Sistema de Kiosco",
    locked: "Bloqueado",
    acknowledged_pass: "Pase Reconocido",
    not_found: "No Encontrado",
    form_components_examples: "Ejemplos de Componentes de Formulario"
  },
  digital_id_card: {
    page_title: "ID Digital",
    digital_id: "ID Digital",
    student_id: "ID Estudiante",
    graduation_year: "Año de Graduación",
    role: "Rol",
    missing_student_id:
      "Este estudiante no tiene un Número de Estudiante en el sistema.",
    suicide_prevention_hotline: "Línea de Prevención de Suicidio",
    suicide_prevention_text: "o llame/envíe un mensaje de texto al 988",
    download_digital_id: "Descargar ID Digital"
  },
  create_pass_student_view: {
    now_pass: "Pase Inmediato",
    appointment_pass: "Pase de Cita",
    late_pass: "Pase Tardío",
    departing_from: "Saliendo de",
    teacher_location: "Maestro/Ubicación",
    teacher_location_placeholder: "Maestro/Ubicación",
    destination: "Destino",
    reason_for_pass_optional: "Motivo del pase (opcional)",
    reason_for_pass_required: "Motivo del pase (requerido)",
    requests_available: "Solicitud(es) Disponibles",
    now_passes_available: "Pases Inmediatos Disponibles",
    appointment_passes_available: "Pases de Cita Disponibles",
    the_module_is_not_available: "El Módulo No Está Disponible",
    this_destination_is_unavailable_until:
      "Este destino no está disponible hasta",
    this_room_is_unavailable_until: "Este salón no está disponible hasta",
    this_adult_is_unavailable_until: "Este adulto no está disponible hasta",
    pass_limit: "Límite de Pases",
    mark_this_pass_as: "Marcar este pase como:",
    successfully_created: "Creado exitosamente.",
    maximum_capacity_of_the_location_has_been_reached:
      "Se ha alcanzado la capacidad máxima de la ubicación. Por favor, inténtelo de nuevo cuando un estudiante regrese.",
    this_location_is_full:
      "Este salón está lleno. Haz clic en 'Enviar' para unirte a la línea, y Pass te notificará cuando sea tu turno.",
    appointment_pass_created_successfully: "Pase de cita creado exitosamente.",
    you_have_location_restrictions:
      "Tienes ({{ restrictions }}) restricciones de ubicación"
  },

  // Appointment Pass specific translations
  appointment_pass: {
    // Page title
    page_title: "Página de Pase de Cita",

    // Table tabs
    next_seven_days: "Próximos 7 Días",
    beyond_seven_days: "Más de 7 Días",
    recurring: "Recurrente",

    // Table headers
    confirmed_canceled: "Confirmado/Cancelado",

    // Status labels
    waiting_confirmation: "Esperando Confirmación",
    canceled: "Cancelado",
    future_apt: "Cita Futura",
    todays_apt: "Cita de Hoy",
    missed_apt: "Cita Perdida",
    ended: "Finalizado",
    on_other_pass: "En otro pase",
    missed_request: "Solicitud Perdida",

    // Table content
    confirmed: "Confirmado",
    cancelled: "Cancelado",
    does_not_repeat: "No se repite",
    acknowledge: "Reconocer",
    requested: "Solicitado",
    created: "Creado",
    expired: "Expirado",

    // Modal titles
    comments_title: "Comentarios",
    cancel_pass_title: "Cancelar Pase",

    // Cancel modal content
    message_placeholder: "Mensaje...",
    cancel_future_occurrences: "Solo Cancelar Ocurrencias Futuras",
    cancel_current_week_and_future:
      "Cancelar Semana Actual Y Ocurrencias Futuras",
    delete_only_this_instance: "Eliminar solo esta instancia",
    delete_entire_series: "Eliminar toda la serie",
    cancel_series_message:
      "Puede haber instancias de esta serie ya programadas en la pestaña 'Próximos 7 Días'. ¿Quieres cancelar todas esas también?",
    delete_instance_message:
      "¿Quieres eliminar solo esta instancia o toda la serie?",

    // Success modal
    appointment_request_sent: "Solicitud de Cita Enviada para",
    apt_menu: "Menú de Citas",

    // Notification
    your_appointment_pass_is_ready: "Tu Pase de Cita está listo",
    from_teacher: "De Maestro",
    from_location: "De Ubicación",
    to_teacher: "A Maestro",
    to_location: "A Ubicación",
    go_to_pass: "Ir al Pase"
  },

  // Updates and Training
  updates: {
    page_title: "Nuevas Versiones",
    no_releases: "No hay versiones",
    pass_updates: "Actualizaciones de Pass",
    release_date: "Fecha de Lanzamiento"
  },

  training: {
    page_title: "Videos de Entrenamiento",
    no_tutorials: "No hay tutoriales en este momento",
    topic: "Tema",
    description: "Descripción"
  },

  admin_guide: {
    page_title: "Guía del Administrador",
    no_tutorials: "No hay tutoriales en este momento"
  },

  quick_reference: {
    page_title: "Referencia Rápida",
    no_data: "No hay datos en este momento"
  },

  // Kiosk specific translations
  kiosk: {
    // General kiosk terms
    kiosk_mode: "Modo Kiosco",
    no_active_kiosk: "No hay kiosco activo.",
    ksk: "KSK",

    // Authentication
    teacher_authentication: "AUTENTICACIÓN DE MAESTRO",
    user_authentication: "Autenticación de usuario",
    code: "Código",
    enter_your_pin: "Ingresa tu PIN",
    kiosk_passcode: "Código de acceso del kiosco",

    // Login methods
    student_number: "Número de Estudiante",
    code_scan: "Escanear código",
    card_scan: "Escanear tarjeta",
    email: "Email",
    enter_student_number_below: "Ingresa tu número de estudiante abajo",
    type_in_student_number: "Escribe el número de estudiante",
    swipe_your_card: "Desliza tu tarjeta",
    click_to_scan_barcode_or_qr: "Haz clic para escanear código de barras o QR",
    type_in_barcode_qr_code: "Escribe el código de barras/código QR",
    scan_your_digital_id_barcode_qr_code:
      "Escanea el código de barras o QR de tu ID digital",

    // Main screen
    from: "De:",
    new_pass: "Nuevo Pase",
    end_pass: "Finalizar Pase",
    departing_from: "Saliendo de",

    // Pass creation
    destination: "Destino",
    reason: "Motivo",
    or_quick_select_from: "o selección rápida de",
    favorites: "Favoritos",
    note: "Nota:",
    the_student_already_has_an_active_pass:
      "El estudiante ya tiene un pase activo.",
    this_screen_will_be_closed_in: "Esta pantalla se cerrará en",
    seconds: "segundos",
    or_click_here_to_close_it_now: "(o haz clic aquí para cerrarla ahora)",

    // Pass status and actions
    your_pass_is_approved: "Tu pase está aprobado.",
    your_pass_request_is_in_the_queue:
      "Tu solicitud de pase está en la fila. Será revisada por un maestro cuando llegue al frente, ya que se ha alcanzado el número máximo de pases para esta ubicación.",
    your_pass_is_created_and_awaiting_approval:
      "Tu pase está creado y esperando aprobación desde el panel de control de tu maestro o desde este kiosco.",
    auto_pass: "Pase Automático",
    time: "Hora",
    staff_use_only: "Solo para personal",
    waiting_approval: "esperando aprobación",
    active: "activo",
    waiting_in_queue: "esperando en fila",
    ended: "Finalizado",
    canceled: "Cancelado",
    cancel: "Cancelar",
    close: "Cerrar",
    approve: "Aprobar",
    start: "Iniciar",
    submit: "Enviar",
    cancel_queue_pass: "Cancelar Pase en Fila",
    please_select_different_teacher_location:
      "Por favor selecciona un maestro/ubicación diferente.",

    // Pass ending
    end_pass_title: "Finalizar Pase.",
    you_do_not_have_an_active_pass: "No tienes un pase activo.",
    cancel_with_timeout: "Cancelar",
    end_pass_button: "Finalizar Pase",

    // Pass status messages
    your_pass_has_successfully_been_ended:
      "Tu pase ha sido finalizado exitosamente.",
    your_queue_pass_has_successfully_been_ended:
      "Tu pase en fila ha sido finalizado exitosamente.",
    your_pass_has_successfully_been_approved:
      "Tu pase ha sido aprobado exitosamente.",
    successfully_logged: "Inicio de sesión exitoso.",
    successfully_created: "¡Creado exitosamente!",
    something_went_wrong: "¡Algo salió mal!",
    this_field_is_required: "Este campo es requerido",
    submission_failed_please_try_again:
      "Envío falló, por favor intenta de nuevo.",

    // Terms and privacy
    terms_of_use: "Términos de Uso",
    privacy_policy: "Política de Privacidad",

    // Unavailability messages
    this_room_is_unavailable_until: "Este salón no está disponible hasta",
    this_adult_is_unavailable_until: "Este adulto no está disponible hasta",

    // Reason placeholders
    reason_for_pass_optional: "Motivo del pase (opcional)",
    reason_for_pass_required: "Motivo del pase (requerido)",

    // Confirmation dialogs
    confirm_cancel_pass: "¿Estás seguro de que quieres cancelar este pase?"
  }
})
